export const editorTags = {
	// BlockType
	'components.controls.blocktype.blockquote': 'Cita',
	'components.controls.blocktype.blocktype': 'Lista',

	// Color Picker
	'components.controls.colorpicker.background': 'Resaltar',

	// Link
	'components.controls.link.link': 'Insertar vínculo',
	'components.controls.link.linkTitle': 'Texto de visualización',
	'components.controls.link.linkTarget': 'URL',

	//Remove
	'components.controls.remove.remove': 'Eliminar formato',
};
